// extracted by mini-css-extract-plugin
export default {"recruitment":"Recruitment_recruitment__elEAc","buttons":"Recruitment_buttons__DMQ68","processes":"Recruitment_processes__zJ-SX","card":"Recruitment_card__WpdNC"};